module.exports = __webpack_public_path__ + "files/f31e0b4fa2bfe404ae94c6bb3ddbe9e1.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/objects-4.png
// module id = 1386
// module chunks = 59